<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <h6>
        <small class="font-weight-bold">
          Security Group Permissions
        </small>
      </h6>
      <button
        class="btn btn-info btn-sm"
        @click="$emit('save')"
      >
        {{ $t('manage-security-group.save-changes') }}
      </button>
    </div>
    <div class="mt-2">
      <h6>
        <small class="font-weight-bold">Security Group Name</small>
      </h6>
      <div class="form-inline">
        <input
          v-model="role.name"
          type="text"
          class="form-control form-control-sm"
          placeholder="New Role"
        >
      </div>
      <div
        v-if="Object.keys(error).length"
        class="text-danger"
      >
        {{ $i18n.locale === 'en' ? error.messageEng : error.messageIdn }}
      </div>
    </div>
    <div class="table-responsive mt-2 pt-2">
      <table class="table table-borderless table-striped">
        <thead>
          <tr>
            <th
              v-for="(column, c) of [...preColumns, ...permissionTypes]"
              :key="c"
              class="text-nowrap"
              :class="{ 'text-center': column.align === 'center' }"
            >
              <div class="font-weight-bold text-capitalize">
                {{ column.name }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(permission, p) of role.permissions"
            :key="p"
          >
            <td
              v-for="column of preColumns"
              :key="column.name"
              class="align-middle"
              :class="{ 'text-center': column.align === 'center' }"
            >
              <!-- CHECK ALL -->

              <div
                v-if="column.name === 'check all'"
                class="custom-control custom-checkbox user-select-none ml-2"
              >
                <input
                  :id="`check-${column.name}-${permission.category}`"
                  :checked="isAllChecked(permission.category)"
                  type="checkbox"
                  class="custom-control-input"
                  @input="checkAllPermission($event, permission.category)"
                >
                <label
                  class="custom-control-label"
                  :for="`check-${column.name}-${permission.category}`"
                />
              </div>

              <div v-else-if="column.name === 'label'">
                {{ permission.name }}
              </div>
            </td>

            <!-- LIST OF TYPES -->

            <td
              v-for="type of permissionTypes"
              :key="type.name"
              class="align-middle"
              :class="{ 'text-center': type.align === 'center' }"
            >
              <div class="custom-control custom-checkbox user-select-none ml-2">
                <input
                  :id="`check-${type.name}-${permission.category}`"
                  v-model="permission.permissions"
                  type="checkbox"
                  class="custom-control-input"
                  :value="type.name"
                >
                <label
                  class="custom-control-label"
                  :for="`check-${type.name}-${permission.category}`"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    role: {
      type: Object,
      default: () => ({})
    },
    preColumns: {
      type: Array,
      default: () => ([])
    },
    permissionTypes: {
      type: Array,
      default: () => ([])
    },
    error: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    // Check or Uncheck all types simultaneously
    checkAllPermission ({ target }, category) {
      this.findCategory(category).permissions = target.checked
        ? [...this.permissionTypes.map(t => t.name)]
        : []
    },
    isAllChecked (category) {
      return this.permissionTypes
        .every(t => this.findCategory(category)
          .permissions
          .includes(t.name)
        )
    },
    findCategory (category) {
      return this.role
        .permissions
        .find(p => p.category === category)
    }
  }
}
</script>
